import React, { useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export const LegalLayout = ({ title, subtitle, children, testId }) => {
  useLayoutEffect(() => {
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = "auto";
    window.scrollTo(0, 0);
    html.style.scrollBehavior = prev;
    const prevTitle = document.title;
    document.title = `${title} | HTS Janzen Hausverwaltung`;
    return () => {
      document.title = prevTitle;
    };
  }, [title]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main data-testid={testId}>
        <section className="bg-gradient-to-b from-brand-50 to-white border-b border-brand-100">
          <div className="max-w-4xl mx-auto px-6 pt-14 pb-12">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-[13px] text-brand-600 hover:text-brand-900 transition-colors"
              data-testid="legal-back-link"
            >
              <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
            </Link>
            <h1 className="mt-6 font-display text-[36px] md:text-[48px] leading-tight font-extrabold text-brand-900">
              {title}
            </h1>
            {subtitle && <p className="mt-3 text-brand-600 text-base md:text-lg">{subtitle}</p>}
          </div>
        </section>
        <article className="max-w-4xl mx-auto px-6 py-14 legal-content">{children}</article>
      </main>
      <Footer />
    </div>
  );
};

export const H2 = ({ children }) => (
  <h2 className="font-display text-[22px] md:text-[26px] font-bold text-brand-900 mt-12 mb-4 first:mt-0">
    {children}
  </h2>
);

export const H3 = ({ children }) => (
  <h3 className="font-semibold text-brand-900 text-base md:text-lg mt-8 mb-2">{children}</h3>
);

export const P = ({ children }) => (
  <p className="text-brand-700 leading-relaxed mb-4 text-[15px] md:text-base">{children}</p>
);

export const UL = ({ items }) => (
  <ul className="list-disc pl-6 space-y-1.5 mb-4 text-brand-700 text-[15px] md:text-base">
    {items.map((it, i) => (
      <li key={i}>{it}</li>
    ))}
  </ul>
);

export const InfoCard = ({ label, children }) => (
  <div className="rounded-2xl border border-brand-100 bg-brand-50/50 p-6">
    <div className="text-[11px] tracking-[0.25em] uppercase text-accent2 font-semibold mb-2">{label}</div>
    <div className="text-brand-900 text-[15px] leading-relaxed">{children}</div>
  </div>
);
